export default "__VITE_ASSET__eb5634d4__"